import axios from './_nestAxios'

export const getPlantilla = filtros => axios.get('/plantillas-cabecera-pie/filtros', { params: filtros })

export const nuevaPlantilla = data => axios.post('/plantillas-cabecera-pie', data)

export const actualizarPlantilla = (_id, data) => axios.put(`/plantillas-cabecera-pie/${_id}`, data)
